'use es6';

import { getPluginSetting } from '../utils';
import { addPreProcessTransform } from '../utils/transformer';
const paddingDirections = ['Top', 'Bottom', 'Left', 'Right'];
export const addTransforms = editor => {
  if (!editor.getParam('useTableContextualToolbar')) return;

  // Replace deprecated `cellpadding` and `border` values with their respective inline-styles
  addPreProcessTransform(editor, dom => {
    const isEmail = getPluginSetting(editor, 'isEmail');
    const tableNodes = dom.querySelectorAll('table');
    Array.from(tableNodes).forEach(tableNode => {
      if (tableNode.hasAttribute('border')) {
        const borderWidth = Number(tableNode.getAttribute('border'));
        let borderStyle = tableNode.style.borderStyle || 'solid';
        if (isEmail && borderWidth === 0) {
          // `border-width` is buggy in Outlook 2016, so additionally set
          // `border-style: none` for email contexts when border is 0
          borderStyle = 'none';
        }
        if (!tableNode.style.borderWidth) {
          editor.dom.setStyles(tableNode, {
            'border-width': borderWidth,
            'border-style': borderStyle
          });
        }
        if (borderWidth) {
          const tableCells = Array.from(tableNode.querySelectorAll('td,th')).filter(
          // Ignore nested table cells
          cellNode => editor.dom.getParent(cellNode, 'table') === tableNode);
          tableCells.forEach(cellNode => {
            if (!cellNode.style.borderWidth && !cellNode.style.border) {
              editor.dom.setStyles(cellNode, {
                'border-width': 1,
                'border-style': borderStyle,
                'border-color': tableNode.style.borderColor
              });
            }
          });
        }
        tableNode.removeAttribute('border');
      }
      if (tableNode.hasAttribute('cellpadding')) {
        const cellPadding = tableNode.getAttribute('cellpadding');
        const tableCells = Array.from(tableNode.querySelectorAll('td,th')).filter(
        // Ignore nested table cells
        cellNode => editor.dom.getParent(cellNode, 'table') === tableNode);
        tableCells.forEach(cellNode => {
          paddingDirections.forEach(dir => {
            const property = `padding${dir}`;
            if (!cellNode.style[property]) {
              editor.dom.setStyle(cellNode, property, `${cellPadding}px`);
            }
          });
        });
        tableNode.removeAttribute('cellpadding');
      }
    });
  });
};